import { axiosInstance } from "../../utils/axios";

export function fetchRefreshCache(): Promise<String> {
  return axiosInstance.get(`/usergroup/refreshcache`, { params: { notShowLoading: true } }).then((resp) => resp.data);
}
